export default __webpack_public_path__ + "static/cityscape1-6dc374dec7604a4bd8f0e414a210ee55.svg";